export default {
  NODE_ENV: "staging",
  API_URL: "https://api-tg.telphin.ru",
  TG_BOT_URL: "https://t.me/ShonovBot"
};
